"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MORTGAGE_LINK = void 0;
const MORTGAGE_LINK = exports.MORTGAGE_LINK = 'https://partner.domrfbank.ru/lk-agent/away/oqwZVpG';